import { Component } from 'react';
import { line as d3Line } from 'd3';

import { type DataPoint, type Series } from './types';

type ScaleFunction = (value: number) => number;

export type LineProps = Readonly<{
  xScale: ScaleFunction;
  yScale: ScaleFunction;
  x: (d: DataPoint) => number;
  y: (d: DataPoint) => number;
  data: Series;
  stroke: string;
  extraClass?: string;
}>;

export class LinePath extends Component<LineProps> {
  public render() {
    const { xScale, yScale, x, y, data, stroke, extraClass } = this.props;
    const lineGenerator = d3Line<DataPoint>()
      .x((d) => xScale(x(d)))
      .y((d) => yScale(y(d)));

    const line = lineGenerator(data as DataPoint[]);
    const baseClass = 'LinePath';
    const className = extraClass ? `${baseClass} ${extraClass}` : baseClass;
    return <path className={className} d={line || ''} stroke={stroke} />;
  }
}
